var map = {
	"./favicons/android-chrome-192x192.png": 9602,
	"./favicons/android-chrome-512x512.png": 2317,
	"./favicons/apple-touch-icon-180x180.png": 814,
	"./favicons/favicon-16x16.png": 2005,
	"./favicons/favicon-32x32.png": 2578,
	"./favicons/favicon.ico": 4862,
	"./favicons/mstile-150x150.png": 5894,
	"./frontend_v1/logo-button.png": 1267,
	"./frontend_v1/logo.png": 8186,
	"./frontend_v2/background/background-1200.jpg": 8372,
	"./frontend_v2/background/background-1280.jpg": 8025,
	"./frontend_v2/background/background-1920.jpg": 7073,
	"./frontend_v2/background/background-2560.jpg": 3749,
	"./frontend_v2/background/background-360.jpg": 2915,
	"./frontend_v2/background/background-3840.jpg": 3369,
	"./frontend_v2/background/background-5120.jpg": 224,
	"./frontend_v2/background/background-600.jpg": 1697,
	"./frontend_v2/background/background-720.jpg": 5564,
	"./frontend_v2/background/background-fallback.png": 8894,
	"./frontend_v2/background/background.heic": 9407,
	"./frontend_v2/background/logo-890x183.png": 7507,
	"./frontend_v2/background/readme.txt": 4304,
	"./frontend_v2/comment-form/image-grey.svg": 3442,
	"./frontend_v2/comment-form/image-white.svg": 2988,
	"./frontend_v2/comment-form/submit.svg": 9301,
	"./frontend_v2/logo-warnet-single--not-used.svg": 7697,
	"./frontend_v2/open-graph-logo.jpg": 4396,
	"./frontend_v2/sidebar-toggle/close.svg": 6088,
	"./frontend_v2/sidebar-toggle/open.svg": 5597,
	"./frontend_v2/sidebar/banner-1024x1536.jpg": 5651,
	"./frontend_v2/zoomable/zoom.svg": 646,
	"./watermarks/logo-warnet.png": 6919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8999;